import styled from 'styled-components';
import { BodyRegular, BodyRegularMedium, BodySmall, BodySmallMedium } from '@src/fonts/typography/Typography';
import { LayoutColors } from '@src/core/theme';
import { device } from '@src/common/breakpoints';

interface LegendBoxProps {
  bgColor?: string;
  borderColor?: string;
}

export const LegendArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const TopArea = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 4px;
`;

export const Legend = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const LegendLabel = styled.span`
  ${BodySmall}
  color: ${LayoutColors.blackMain}

  ${device.mobile} {
    ${BodyRegular}
  }
`;

export const LegendLabelSuggestedPrice = styled.span`
  ${BodySmallMedium}
  color: ${LayoutColors.blackMain}

  ${device.mobile} {
    ${BodyRegularMedium}
  }
`;

export const LegendBox = styled.div<LegendBoxProps>`
  width: 25px;
  height: 16px;
  border-radius: 4px;
  border: 2px solid ${(props) => props.borderColor ?? 'transparent'};
  background-color: ${(props) => props.bgColor ?? 'transparent'};
`;
